import Vue from 'vue'
import App from './App.vue'
import Lx from './utils/lxMap.js'
import Ajax from './utils/ajax'
import Tap from './utils/tap'
import Toast from './components/toast/index'
import Modal from './components/modal/index'
import KNBBridge from './utils/bridge.js'
if (['development', 'test'].includes(process.env.VUE_APP_ENV)) {
  import('@era/coverage-report').then((coverage) => {
    coverage.initOrange({
      projectKey: 'union-pay-hybrid',
      commitId: AWP_GIT_COMMIT_ID,
    })
  })
}
Vue.use(Tap)
Vue.config.productionTip = false
Vue.prototype.$ajax = Ajax
Vue.prototype.$toast = Toast
Vue.prototype.$modal = Modal
Vue.prototype.$lx = Lx
Vue.prototype.$eb = new Vue()
Vue.prototype.$bridge = new KNBBridge()
new Vue({
  render: (h) => h(App),
}).$mount('#app')
